'use strict';

var React = require('react'),
    Group = require('../organisms/Group'),
    SidebarBody = require('../organisms/SidebarBody'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ActivityListStore = require('../stores/ActivityListStore'),
    UserStore = require('../stores/UserStore'),
    ActivityActionCreators = require('../actions/ActivityActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var ACTIVITY_PAGE_POLL_INTERVAL = 3000;

if ('production' !== process.env.NODE_ENV) {
  ACTIVITY_PAGE_POLL_INTERVAL *= 10;
}

var Activities = React.createClass({
  mixins: [createStoreMixin(ActivityListStore), PureRenderMixin],

  getStateFromStores() {
    var activities = ActivityListStore.getActivities();

    return {
      activities: activities
    };
  },

  componentDidMount() {
    ActivityActionCreators.requestActivityPage(true);

    this.activitiesInterval = setInterval(() => {
      ActivityActionCreators.requestActivityPage(true);
    }, ACTIVITY_PAGE_POLL_INTERVAL);
  },

  componentWillUnmount() {
    ActivityActionCreators.markAll();

    clearInterval(this.activitiesInterval);
  },

  render: function () {
    var userId = UserStore.getMe().id;

    return (
      <SidebarBody title='Notifications'>
        <Group type='activities'
               items={this.state.activities}
               context='sidebar'
               mode='list'
               isExpectingPage={ActivityListStore.isExpectingPage(userId)}
               isLastPage={ActivityListStore.isLastPage(userId)}
               isInvalidated={ActivityListStore.isInvalidated(userId)}
               loadNextPage={this.requestNextPage} />
      </SidebarBody>
    );
  },

  requestNextPage() {
    ActivityActionCreators.requestActivityPage();
  }
});

module.exports = Activities;



/** WEBPACK FOOTER **
 ** ./sidebar/Activities.jsx
 **/